<template>
	<div id="main">
		<el-container>
			<el-header class="header">
				<headerBox :userObj="userObj"></headerBox>
			</el-header>
			<div class="context disBetween">
				<el-aside width="180px">
					<menuList ref="menuList"></menuList>
				</el-aside>
				<el-main>
					<router-view class="view" @setPath="setPath"></router-view>
				</el-main>
			</div>
		</el-container>
	</div>
</template>

<script>
	import headerBox from "@/components/headerBox.vue"
	import menuList from "@/components/menuList.vue"
	export default {
		name: "",
		components: {
			headerBox,
			menuList
		},
		data() {
			return {
				userObj:{
					warnNum:62,
					userName:"我是用户信息"
				}
			};
		},
		mounted() {
		},
		methods: {
			setPath(path){
				console.log(path)
				this.$refs.menuList.selectmenu(path)
			}
		},
		computed: {},
		created() {},
	};
</script>

<style lang="scss" scoped>
	@import './mainHome.scss';
</style>
